export default "__VITE_ASSET__In3_cz2$__"